import React from 'react';
import styled from 'styled-components';

import { Container, Row, Col, Paragraph, HeadingFive } from '../';

const GreetingImg = styled.div`
  height: 90px;
  margin-top: 40px;
  align-items: flex-end;
  display: flex;
  justify-content: center;
`;

// eslint-disable-next-line react/display-name
export default () => (
  <Container>
    <Row>
      <Col xs={12} md={4} pr={{ xs: 0.2, md: 2 }} center>
        <GreetingImg>
          <img src="https://assets.homeimprovementpages.com.au/images/alexa/row-1.png" />
        </GreetingImg>
        <HeadingFive mt={1.5}>Say what kind of tradie you need</HeadingFive>
        <Paragraph mt={1} style={{ fontSize: '15px' }}>
          Whether you need a builder, an arborist, a plumber or a stonemason, hipages has you
          covered. Just tell Alexa what you need and we&apos;ll help you connect with qualified
          tradies.
        </Paragraph>
      </Col>
      <Col xs={12} md={4} pl={{ xs: 0.2, md: 2 }} pr={{ xs: 0.2, md: 2 }} center>
        <GreetingImg>
          <img src="https://assets.homeimprovementpages.com.au/images/alexa/row-2.png" />
        </GreetingImg>
        <HeadingFive mt={1.5}>Tell Alexa where the job is</HeadingFive>
        <Paragraph mt={1} style={{ fontSize: '15px' }}>
          Tell Alexa your postcode and we’ll look for the nearest tradies that match.
        </Paragraph>
      </Col>
      <Col xs={12} md={4} pl={{ xs: 0.2, md: 2 }} center>
        <GreetingImg>
          <img src="https://assets.homeimprovementpages.com.au/images/alexa/row-3.png" />
        </GreetingImg>
        <HeadingFive mt={1.5}>Get connected or receive a listing</HeadingFive>
        <Paragraph mt={1} style={{ fontSize: '15px' }}>
          hipages connects you directly with tradies to help get your job done. We can also pass on
          details of tradies if you prefer to do the calling at your own convenience.
        </Paragraph>
      </Col>
    </Row>
  </Container>
);
